var exports = {
  "Gt": "OtherAccountAvatar.module__frame___UXdXOW",
  "z5": "OtherAccountAvatar.module__cutout___UXdXOW",
  "qS": "OtherAccountAvatar.module__badge___UXdXOW",
  "Nw": "OtherAccountAvatar.module__badgeHighlighted___UXdXOW",
  "rF": "OtherAccountAvatar.module__badgeIcon___UXdXOW",
};

module.exports = exports;
